import formatDate from '@/utils/formatDate'
import useRequest from '@/compositions/useRequest'
import { download } from '@/utils/download'

export default {
  name: 'Document',
  props: {
    id: Number,
    documentType: String,
    file: Object,
    name: String,
    createdAt: String,
    canDelete: Boolean,
    isNew: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    isDriver: {
      type: Boolean,
      default: false,
    },
  },
  setup({ createdAt, id }, context) {
    const { $store } = context.root

    const { loading, makeRequest } = useRequest({
      context,
      request: () => $store.dispatch('data/deleteDocument', { documentId: id }),
      successMessage: 'Документ удален',
    })

    const remove = async () => {
      await makeRequest()
      context.emit('success')
    }
    return {
      date: createdAt ? formatDate(new Date(createdAt)) : undefined,
      extension: '',
      loading,
      download,
      remove,
    }
  },
}
